import { SboCurrency } from '@nami/domain/classes'
import { AccountTier } from '@/enum/AccountTier'

export class UserInfo {
    firstName: string = ''
    lastName: string = ''
    fullName: string = ''
    isInitialDepositDone: boolean = false
    initDepositExpiredDay: number = 0
    isKyc: boolean = false
    accountTier: AccountTier = AccountTier.New
    createdOn: Date = new Date()
    accountId: string = ''
    katakana: string | null = null
    cpf: string | null = null
    currency: SboCurrency = new SboCurrency()
    isRequiredKyc: boolean = false
    isAllowUsingEwallet: boolean = false
    residentCountryCode: string = ''
    isAllowUsingLocalPayment: boolean = true

    constructor(data: PartialProps<UserInfo> = {}) {
        Object.assign(this, data)
    }

    get isNeedToFillInKatakana(): boolean {
        return this.katakana === null
    }
}
